<template>
  <MenuComponent
    :custom_title="$t('Menu.OrganizerSettings')"
    :filtred_count="settingsItem.countFiltered">
    <template #navbar="{ navbarMini }">
      <NavBar
        :active="activeMenyIndex"
        :class="{'mini': navbarMini}"
        :head-block-height="colapseNavbar ? '65px' : '130px'"
        :loading="loading"
        :mode="navbarMini"
        :types="filteredMenuTypes"
        unload
        @filterItems="choseType">
        <div
          slot="headBlock"
          :class="navbarMini ? 'mt-6 mb-2 mx-2' : 'mt-8 mb-2 mx-2'">
          <sButton
            :class="navbarMini ? '' : 'width-100'"
            data-qa="btn-nav-bar"
            :disabled="loading"
            :icon="navbarMini ? 'plus' : ''"
            style="margin: auto auto 0;"
            @click="createSettings">
            <span
              v-if="!navbarMini"
              data-qa="btn-nav-bar-text">{{ $t('OrgSettings.AddedOrgSetting') }}</span>
          </sButton>
          <sInput
            v-if="!navbarMini"
            class="mt-3"
            clearable
            :disabled="loading"
            :placeholder="$t('OrgSettings.FindSetting')"
            :value.sync="searchFilterByType"
            @change="changeSearchFilterByType"/>
        </div>
        <template #after_scroll>
          <PinnedFiltersTemplatesTenders
            ref="filters_templates"
            :edited="false"
            :filters="fastFilters"
            :small="navbarMini"
            @click="updatePinnedFilters"/>
          <sDivider/>
        </template>
      </NavBar>
    </template>
    <template #filter>
      <sButton
        class="my-auto"
        small
        type="text"
        @click="showModalCopy(null, 'all')">
        {{ $t('Common.Copy') }}
      </sButton>
      <sPopover
        ref="popoverFilter"
        class="my-auto pr-1"
        :disabled="loading"
        :open-delay="300"
        placement="bottom-end"
        popper-class="menu"
        trigger="click"
        width="402"
        @hide="hideFilterMenu">
        <div
          slot="reference"
          :class="{'dot': defaultSettings || filters.organizationIds.length}">
          <sBadge
            :color="defaultSettings || filters.organizationIds.length ? 'red' : 'transparent'"
            :content="defaultSettings || filters.organizationIds.length"
            :dot="true"
            :offset-x="-1"
            overlap>
            <sButton
              class="px-2"
              data-qa="btn-open-filter"
              :disabled="loadingList.items"
              icon="filter"
              small
              type="text">
              {{ $t('Planning.Filter') }}
            </sButton>
          </sBadge>
        </div>
        <div
          class="pa-6">
          <div class="grey--text h6-text pb-4">
            {{ $t('OrgSettings.AddedNeedConditions') }}
          </div>
          <div
            class="block-filters">
            <template
              v-if="availableDefaultSettings">
              <label class="label-filter">
                {{ $t('Common.ByDefault') }}
              </label>
              <sSwitch
                v-model="defaultSettings"
                class="ml-2 my-auto"
                data-qa="godmode-btn"
                @input="() => {$refs.popoverFilter.showPopper=false; refreshAll(true)}"/>
              <div/>
            </template>
            <div class="label-filter">
              {{ $t('Common.Organization') }}
            </div>
            <OrgsList
              ref="orgsList"
              data-qa="select-organization"
              :disabled="defaultSettings"
              key-field="organizationId"
              :model.sync="filters.organizationIds"
              :multiple="true"
              :organizations="availableOrganizations"
              placeholder="Common.Organization"
              :readonly="loadingList.items"
              :return_object="false"
              @click.stop/>
            <div class="my-auto ml-2">
              <sButton
                :disabled="!filters.organizationIds.length || defaultSettings"
                icon="cancel"
                small
                type="text"
                @click="() => {$refs.popoverFilter.showPopper=false; filters.organizationIds=[]}"/>
            </div>
          </div>
        </div>
      </sPopover>
      <SearchInput
        debounce
        :disabled="loading || defaultSettings"
        :search.sync="filters.search"
        @input="refreshAll(true)"/>
      <ModeButtons
        class="ml-4"
        :disabled="loading"
        :mode="tableMode"
        @update:mode="choiseTableMode"/>
    </template>
    <template #items>
      <sAlert
        v-if="isTesterOrgs"
        type="warning">
        {{ $t('Common.WarningTitle') }}
        <template slot="desc">
          {{ $t('Common.orgToTesting') }}
        </template>
      </sAlert>
      <OrganizerSettingEdit
        v-if="actionModal.mode === 'edit' || actionModal.mode === 'create'"
        :loading.sync="actionModal.loading"
        :show.sync="actionModal.show"
        :value.sync="actionModal.model.item"
        @close="closeModalAndClearModel"
        @create="refreshAll(true)"
        @edit="editSuccess"/>
      <OrganizerSettingCopy
        v-else-if="actionModal.mode === 'copy'"
        :copy-props="copyModal.copyProps"
        :loading.sync="actionModal.loading"
        :mode="copyModal.mode"
        :organization="copyModal.organization"
        :show.sync="copyModal.show"
        @close="closeModalAndClearModel"
        @success="copySuccess"/>
      <ScrollShadow
        class="width-100 height-100 mt-2"
        :padding-delta="200"
        @scrolledToBottom="infinityLoad">
        <VuetiTable
          v-if="!loadingList.page && tableMode"
          id="orgSettings"
          ref="table"
          :headers="tableHeader"
          item_key="settingOrganizationId"
          :items="settingsItem.items"
          :loading="loadingList.page"
          :selected.sync="choosed_items"
          table-class="settings-table">
          <template #[`header.menu`]="{}">
            <div/>
          </template>
          <template #[`header.userCount`]="{ header }">
            <sTooltip
              :border="false"
              :content="header.text"
              :open-delay="300"
              placement="bottom"
              popper-class="info-tooltip"
              type="white">
              <sIcon
                color="var(--v-secondary__green_not_active-base)"
                type="person"/>
            </sTooltip>
          </template>
          <template #[`item.organizationTitle`]="{ item }">
            <div>
              <div
                class="value-key"
                data-qa="tttt">
                {{ $t('Common.Code') }}: {{ item.usreou || item.organizationView.usreou }}
              </div>
              <div
                class="value-label pointer"
                style="display: block;"
                @click="findSettingsByOrg(item.organizationView)">
                <span>{{ $t('Common.Name') }}:</span>
                <span class="ml-1">{{ item.organizationTitle || item.organizationView.organizationTitle }}</span>
              </div>
            </div>
          </template>
          <template #[`item.settingTitle`]="{ item }">
            <div>
              <div class="value-key">
                {{ $t('Common.Code') }}: {{ item.settingOldCode || item.settingInfo.settingOldCode }}
              </div>
              <div class="value-label">
                {{ $t('Common.Name') }}:
                <span class="ml-1">{{ item.settingTitle || item.settingInfo.settingTitle }}</span>
              </div>
            </div>
          </template>
          <template #[`item.settingValue`]="{ item }">
            <SettingValueView
              :loading="loading"
              :value="item"
              @changeValue="editOrganizerSetting"/>
          </template>
          <template #[`item.userCount`]="{ item }">
            <div class="value-label text-center">
              {{ item.userCount ? item.userCount : "-" }}
            </div>
          </template>
          <template #[`item.menu`]="{ item, index: rowIndex }">
            <OrganizerSettingMenu
              v-if="!loading"
              slot="menu"
              :data-qa="`table-row-${rowIndex}-menu`"
              :item="item"
              @delete="deleteItem"
              @edit="editItem"
              @showModalCopy="showModalCopy"/>
          </template>
        </VuetiTable>
        <template
          v-else-if="!loadingList.page">
          <template
            v-if="settingsItem.items.length">
            <OrganizerSettingCard
              v-for="(filtredField, filtredFieldIndex) in settingsItem.items"
              :key="`setting-card-${filtredField.settingOrganizationId}`"
              :class="{'mb-5': filtredFieldIndex != (settingsItem.items.length - 1)}"
              :index="filtredFieldIndex"
              :item="filtredField"
              @filterOrg="findSettingsByOrg">
              <SettingValueView
                slot="value"
                :loading="loading"
                :value="filtredField"
                @changeValue="editOrganizerSetting"/>
              <OrganizerSettingMenu
                :key="`setting-menu-${filtredField.settingOrganizationId}`"
                slot="menu"
                :data-qa="`card-${filtredFieldIndex}-menu`"
                :item="filtredField"
                @delete="deleteItem"
                @edit="editItem"
                @showModalCopy="showModalCopy"/>
            </OrganizerSettingCard>
          </template>
          <EmptyBlock
            v-else-if="!loading"
            :text="$t('Tenders.NoResultsForSearch')"/>
        </template>
        <div
          v-if="loadingList.page || loadingList.items"
          class="my-5">
          <sIcon
            class="my-auto mr-2"
            color="var(--white-color)"
            size="36"
            spin
            type="loading"/>
        </div>
      </ScrollShadow>
    </template>
  </MenuComponent>
</template>
<script>
import { mapGetters } from 'vuex'
import { debounce } from 'toolkit/utils/util'
import { storageMixin } from 'mixins'

import NavBar from 'components/common/blocks/NavBar.vue'
import MenuComponent from 'pages/templates/MenuComponent.vue'
import ScrollShadow from 'components/common/ScrollShadow.vue'
import OrgsList from 'components/common/elements/OrgsList.vue'
import EmptyBlock from 'components/common/elements/EmptyBlock.vue'
import SearchInput from 'components/common/inputs/SearchInput.vue'
import ModeButtons from 'components/common/elements/ModeButtons.vue'
import VuetiTable from 'components/common/blocks/table/VuetiTable.vue'
import OrganizerSettingEdit from 'components/organizer-settings/OrganizerSettingEdit.vue'
import OrganizerSettingCopy from 'components/organizer-settings/OrganizerSettingCopy.vue'
import OrganizerSettingMenu from 'components/organizer-settings/OrganizerSettingMenu.vue'
import OrganizerSettingCard from 'components/organizer-settings/OrganizerSettingCard.vue'

import PinnedFiltersTemplatesTenders from 'components/common/blocks/PinnedFiltersTemplatesTenders.vue'

import organizerSettings from 'mixins/organizerSettings'

import OrganizerSettingApi from '@/api/organizerSettingApi'
const organizer_setting_api = new OrganizerSettingApi()

export default {
  name: 'organizerSettingsPage',
  mixins: [storageMixin, organizerSettings],
  data() {
    return {
      fastFilters: [
        {
          id: 'used',
          filterName: 'Використовуються',
        }
      ],
      fastFilterId: null,
      choosed_items: [],
      activeMenyIndex: 0,
      defaultSettings: false,
      copyModal: {
        mode: 'one',
        organization: {},
        copyProps: [],
        show: false
      },
      actionModal: {
        show: false,
        loading: true,
        model: {
          item: null,
          fromOrganizationId: null,
          toOrganizationId: null,
        },
        mode: 'copy',
      },
      tableHeader: [
        {text: '', value: 'data-table-select' },
        {
          text: this.$t('OrgSettings.OrgTitle'),
          value: 'organizationTitle',
          disableFilter: false,
          sortable: false
        },
        {
          text: this.$t('OrgSettings.setting'),
          value: 'settingTitle',
          disableFilter: true,
          sortable: false
        },
        {
          text: this.$t('OrgSettings.settingValue'),
          value: 'settingValue',
          width: '50px',
          disableFilter: true,
          sortable: false
        },
        {
          text: this.$t('OrgSettings.SettingUserCount'),
          value: 'userCount',
          width: '7px',
          sortable: false
        },
        {
          text: this.$t('OrgSettings.Menu'),
          value: 'menu',
          width: '35px',
          sortable: false
        }
      ],
      spr: {
        settings: []
      },
      tableMode: true,
      filters: {
        search: null,
        settingsIds: [],
        organizationIds: []
      },
      searchFilterByType: null,
      settingsCounts: [],
      settingsItem: {
        items: [],
        count: 0,
        countFiltered: 0,
        show: 15,
        skip: 0
      },
      loadingList: {
        page: true,
        items: false,
        settings: false,
        // menyItemByLocal: true, // Уже считали сохраненный пункт меню из LocalStore
      },
      menuTypes: [],
      scrolling: false,
      oldFilter: null,
      customOrg: null,
      colapseNavbar: false,
    }
  },
  methods: {
    updatePinnedFilters(filterTemplate) {
      this.fastFilterId = filterTemplate?.id === this.fastFilterId ? null : filterTemplate?.id

      this.activeMenyIndex = 0
      this.filters.settingsIds = []
      this.getOrgSettings()
    },
    actionOrgSettings(params) {
      if (params.name === 'copy') {
        this.showModalCopy(params.params, 'choise')
      } else if (params.name === 'delete') {
        this.deleteMultiSettings(params.params)
      }
    },
    deleteMultiSettings(props) {
      let content = `${this.$t('OrgSettings.setting')}:</br><ul>`
      props.settings.slice(0, 5).forEach(setting => {
        content += `<li><u>${setting.settingTitle}</u></li>`
      })
      if (props.settings.length > 5) {
        content += `</br>...${this.$t('Purchasing.More')}: ${ props.settings.length - 5 }`
      }
      content += '</ul>'
      const execDeleteAll = async () => {
        await Promise.all(this.choosed_items.map(item => this.$_deleteSetting(item)))
        this.refreshAll(true)
      }
      this.$Modal.confirm({
        title: `${this.$t('OrgSettings.DeleteQuestin')}?`,
        content,
        closable: true,
        okText: this.$t('Purchasing.Remove'),
        cancelText: this.$t('Common.Close'),
        dangerouslyUseHTMLString: true,
        onOk: execDeleteAll,
      })
    },
    changeSizeNavbar(val) {
      this.colapseNavbar = val
    },
    changeSearchFilterByType: debounce(function () {
      if (this.activeMenyIndex != 0) {
        this.choseType(this.filteredMenuTypes[0])
      }
      this.saveToLocal()
    }, 250),
    editOrganizerSetting(props) {
      const model = {
        settingOrganizationId: props.settingOrganizationId,
        settingValue: props.newValue,
        users: []
      }
      organizer_setting_api.editOrganizerSetting(model)
        .then(res => {
          if (res.success) {
            const item = this.settingsItem.items.find(i => i.settingOrganizationId === props.settingOrganizationId)
            if (item) {
              item.settingValue = props.newValue
            }
          }
        })
    },
    findSettingsByOrg(org) {
      this.filters.organizationIds = org ? [org.organizationId] : []
      if (org && this.$refs.orgsList) {
        if (!this.$refs.orgsList.organizations.find(i => i.organizationId === org.organizationId)) {
          this.customOrg = {
            organizationId: org.organizationId,
            title: `${org.organizationTitle} (${org.usreou})`,
            itleWithoutOkpo: org.organizationTitle,
            oKPO: org.usreou,
          }
        }
      }
      this.hideFilterMenu()
    },
    hideFilterMenu() {
      let oldFilter = {}
      if (this.oldFilter) {
        oldFilter = JSON.parse(this.oldFilter)?.filters
      }
      if (JSON.stringify(oldFilter) !== JSON.stringify(this.filters)) {
        if (!this.filters.organizationIds.find(i => i === this.customOrg?.organizationId)) {
          this.customOrg = null
        }
        this.refreshAll(true)
      }
    },
    exportToExcel() {
      //console.warn('exportToExcel')
    },
    saveToLocal: debounce(async function () {
      const params = {
        filters: this.filters,
        tableMode: this.tableMode,
        defaultSettings: this.defaultSettings,
        filterByType: this.searchFilterByType
      }
      if (this.oldFilter === JSON.stringify(params)) { return }
      await this.$_savePropToDBStorage('orgSettings_pageProp', this.$_.cloneDeep(params)).then(() => {
        this.oldFilter = JSON.stringify(params)
      })
    }, 250),
    choiseTableMode(mode) {
      this.tableMode = mode
      this.saveToLocal()
    },
    choseType(type) {
      const index = this.filteredMenuTypes.findIndex(i => i.type === type.type)
      const needChange = !this.filters.settingsIds?.length || this.filters.settingsIds[0] !== type.type
      if (index !== -1 && needChange) {
        this.activeMenyIndex = index
        this.filters.settingsIds = type.type === 'all' ? [] : [type.type]
        if (type.count) {
          this.refreshAll(false)
        } else {
          this.settingsItem.skip = 0
          this.settingsItem.countFiltered = 0
          this.settingsItem.items = []
        }
      }
    },
    async refreshAll(needStat = false) {
      this.settingsItem.skip = 0
      this.settingsItem.count = 0
      this.settingsItem.countFiltered = 0
      this.settingsItem.items = []
      this.loadingList.page = needStat
      await this.getOrgSettings(needStat)
    },
    getOrgSettings: debounce(async function (needStat) {
      if (this.loadingList.items) {
        return
      }
      this.choosed_items = []
      this.loadingList.items = true
      if (this.defaultSettings) {
        //this.activeMenyIndex = 0
        this.filters.search = null
        //this.filters.settingsIds = []
        this.filters.organizationIds = []
      }
      const params = {
        organizationIds: this.defaultSettings ? [0] : (this.filters.organizationIds || [] ),
        settingsIds: this.filters.settingsIds || [],
        searchPhrase: this.filters.search,
        skipCount: this.settingsItem.skip,
        takeCount: this.settingsItem.show
      }
      const getStat = new Promise(async (resolve) => {
        if (!needStat) {
          resolve()
          return
        }
        await organizer_setting_api.getOrganizerSettingStatistics(this.$_.cloneDeep(params))
          .then(statRes => {
            const settingsCounts = statRes?.settingsCounts || []

            this.settingsItem.count = statRes?.rowsCount || 0
            this.settingsCounts = settingsCounts
              .reduce((obj, item) => Object.assign(obj,
                {
                  [item.key]: item.value
                }
              ), {})
            this.setMenyTypes()
            resolve(this.settingsCounts)
          })
      })
      const getItems = new Promise(async (resolve) => {
        await organizer_setting_api.getOrganizerSettings(this.$_.cloneDeep(params))
          .then(res => {

            this.settingsItem.countFiltered = res?.rowsCount || 0
            this.settingsItem.items = []
              .concat(this.settingsItem.items)
              .concat(res?.rows || [])
            resolve(res)
          })
      })
      const checkCustomOrg = new Promise(async (resolve) => {
        const organizationIds = (this.settings.availableOrganizations || []).map(i => i.organizationId)
        const customOrgId = (this.filters.organizationIds || []).find(i => !organizationIds.includes(i))
        if (customOrgId) {
          const customOrg = this.settingsItem.items
            .find(i => i.organizationView.organizationId === customOrgId)?.organizationView
          || {
            organizationId: customOrgId,
            organizationTitle: `${this.$t('Common.Organization')} ${customOrgId}`,
            oKPO: null
          }

          this.findSettingsByOrg(customOrg)
        }
        resolve()
      })
      this.saveToLocal()
      Promise.all([getStat, getItems, checkCustomOrg])
        .then(() => {
          this.settingsItem.skip += this.settingsItem.show
        })
        .finally(() => {
          this.loadingList.page = false
          this.loadingList.items = false
        })
    }, 250),
    /**
    * формируем эллементы для левого меню
    */
    async setMenyTypes() {
      const itemSettings = this.spr.settings
        .map(setting => {
          const filter = el => {
            return el.settingInfo.settingId === setting.type
          }
          return {
            name: setting.name,
            type: setting.type,
            typeString: setting.settingType,
            icon: 'setting',
            oldCode: setting.settingOldCode,
            class: 'pl-7 setting-meny-item',
            count: this.settingsCounts[setting.type],
            filter: filter
          }
        })

      this.menuTypes = [
        {
          name: this.$t('OrgSettings.MenuAll'),
          type: 'all',
          typeString: 'all',
          icon: 'category',
          class: 'setting-meny-item',
          count: this.settingsItem.count
        }
      ].concat(
        itemSettings
      )

      this.$nextTick(() => {
        if (this.filters.settingsIds?.length === 0) {
          this.activeMenyIndex = 0
        } else {
          const index = this.filteredMenuTypes.findIndex(i => i.type === this.filters.settingsIds[0])
          this.activeMenyIndex = index !== -1 ? index : 0
        }
      })
    },
    infinityLoad: debounce(async function () {
      if (this.settingsItem.items?.length < this.settingsItem.countFiltered) {
        await this.getOrgSettings(false)
      }
    }, 250),
    /**
     * Загружаем общий справочник настроек
     */
    async getSettingsList() {
      this.loadingList.settings = true

      await organizer_setting_api.getSettingView()
        .then(res => {
          if (res) {
            this.spr.settings = res.map(i => ({
              name: i.settingTitle,
              type: i.settingId,
              settingOldCode: i.settingOldCode,
              settingType: i.settingType,
              show: true
            }))
          } else {
            this.$notice.error({
              title: this.$t('Common.ErrorTitle'),
              message: this.$t('OrgSettings.Errors.GetSettings'),
              duration: 10,
            })
          }
        })
        .finally(() => (this.loadingList.settings = false))
    },
    createSettings() {
      this.actionModal.loading = true
      this.actionModal.mode = 'create'
      this.actionModal.model.item = {
        organizationView: {
          organizationId: null,
          organizationTitle: '',
          usreou: ''
        },
        settingId: this.menuTypes[this.activeMenyIndex].type !== 'all' ? this.menuTypes[this.activeMenyIndex].type : null,
        userCount: 0,
        settingInfo: {
          availableValues: {},
          notAvailableSetUserValue: false,
          settingId: null,
          settingOldCode: null,
          settingTitle: null,
          settingType: null,
        },
        settingOrganizationId: null,
        settingValue: null,
        users: []
      }
      this.actionModal.loading = false

      this.$nextTick(() => {
        this.actionModal.show = true
      })
    },
    editSuccess(value) {
      const item = this.settingsItem.items.find(i => i.settingOrganizationId === value.settingOrganizationId)
      if (item) {
        item.settingValue = value.settingValue
        item.userCount = value.users?.length
      }
    },
    closeModalAndClearModel() {
      this.actionModal.model.item = null
      this.actionModal.model.fromOrganizationId = null
      this.actionModal.model.toOrganizationId = null
      //this.actionModal.from = {}
    },
    async editItem(item) {
      if (!this.acessSettingTypes.includes(item.settingInfo.settingType)) {
        this.$notice.info({
          title: this.$t('OrgSettings.SettingTypeNotSupport'),
          message: this.$tc('OrgSettings.SettingTypeNotSupportMessage', item.settingInfo.settingType),
          duration: 10,
          dangerouslyUseHTMLString: true,
        })
        return
      }

      this.actionModal.loading = true
      this.actionModal.mode = 'edit'
      this.actionModal.model.item = {
        organizationView: item.organizationView,
        settingId: item.settingInfo.settingId,
        userCount: item.userCount,
        settingInfo: {
          availableValues: {},
          notAvailableSetUserValue: true,
          settingId: item.settingInfo.settingId,
          settingOldCode: item.settingInfo.settingOldCode,
          settingTitle: item.settingInfo.settingTitle,
          settingType: item.settingInfo.settingType,
          settingOrganizationId: item.settingOrganizationId,
          settingValue: item.settingValue,
          users: []
        }
      }
      this.$nextTick(() => {
        this.actionModal.show = true
      })
      await organizer_setting_api.getOrganizerSettingDetail(item.settingOrganizationId)
        .then(res => {
          if (res) {
            if (!this.acessSettingTypes.includes(res?.settingInfo?.settingType)) {
              this.actionModal.show = false
            } else {
              this.$set(this.actionModal.model, 'item', res)
            }
          } else {
            this.$notice.error({
              title: this.$t('Common.ErrorTitle'),
              message: this.$t('Errors.STHWrong'),
            })
          }
        })
        .finally(() => (this.actionModal.loading = false))
    },
    deleteItem(item) {
      const index = this.settingsItem.items.findIndex(i => i.settingOrganizationId === item.settingOrganizationId)

      if (index !== -1 ) {
        this.settingsItem.items.splice(index, 1)
        this.$log('delete item', item)
      }
    },
    async copySuccess(result) {
      if (result.toOrganizationId) {
        this.filters.organizationIds = [result.toOrganizationId]
        this.filters.search = null
        this.filters.settingsIds = result.settingsIds || []
      }
      await this.refreshAll(true)
    },
    showModalCopy(item, mode = 'one') {
      item = item || {}
      this.copyModal.mode = mode
      //this.actionModal.mode = 'copy'
      if (mode === 'choise') {
        this.copyModal.organization = {
          organizationId: item?.organizationView.organizationId,
          title: item?.organizationView.organizationTitle
        }
        this.copyModal.copyProps = item?.settings
      } else if (mode === 'all') {
        this.copyModal.organization = {}
        this.copyModal.copyProps = null
      } else {
        this.copyModal.organization = {
          organizationId: item?.organizationView.organizationId,
          title: item?.organizationView.organizationTitle
        }
        this.copyModal.copyProps = item
      }
      this.$nextTick(() => {
        this.actionModal.loading = false
        this.copyModal.show = true
      })
    },
  },
  computed: {
    ...mapGetters({
      settings: 'getSettings',
    }),
    availableDefaultSettings() {
      return this.$store.getters['GET_USER']?.tenderSettings?.accessRole?.some(el => el == 'FRONTOFFICEADMIN'
        || el == 'ADMIN')
    },
    availableOrganizations() {
      let result = this.$_.cloneDeep(this.settings.availableOrganizations) || []
      if (this.customOrg) {
        result = result.concat([this.customOrg])
      }
      return result
    },
    filteredMenuTypes() {
      if (!this.searchFilterByType && !this.fastFilterId) {
        return this.menuTypes
      }
      let result = []
      if (this.searchFilterByType) {
        result.push(...this.menuTypes
          .filter(i =>
            i.type === 'all' ||
            i.oldCode?.toLowerCase()
              .includes(this.searchFilterByType.toLowerCase()) ||
            i.name?.toLowerCase()
              .includes(this.searchFilterByType.toLowerCase()) ||
            i.typeString?.toLowerCase()
              .includes(this.searchFilterByType.toLowerCase()) ||
            i.settingOldCode?.toLowerCase()
              .includes(this.searchFilterByType.toLowerCase())
          ))
      } else {
        result = this.menuTypes
      }

      if (this.fastFilterId) {
        switch (this.fastFilterId) {
        case 'used':
          result = result?.filter(i => i.count)
          break
        default:
          break
        }
      }

      return result
    },
    loading() {
      return this.loadingList.page || this.loadingList.items || this.loadingList.settings/* || this.loadingList.menyItemByLocal*/
    }
  },
  watch: {
    choosed_items: {
      immediate: true,
      deep: true,
      handler(newValue) {
        const options = {
          name: 'orgSettings'
        }
        if (newValue?.length) {
          const countUsreou = [...new Set(newValue.map(i => i.organizationView.usreou))]

          if (countUsreou?.length === 1) {
            options.params = {
              organizationView: newValue.find(i => i.organizationView.usreou === countUsreou[0]).organizationView,
              settings: newValue.map(i => i.settingInfo)
            }

            this.$root.$emit('showSnackbar', options)
          } else {
            this.$root.$emit('closeSnackbar', options)
          }
        } else {
          this.$root.$emit('closeSnackbar', options)
        }
      }
    }
  },
  async created() {
    await this.getSettingsList()
    await this.$_getPropFromDBStorage('orgSettings_pageProp', {})
      .then(async (pageProp) => {
        this.tableMode = pageProp?.tableMode || false
        this.searchFilterByType = pageProp?.filterByType || null
        this.filters = pageProp?.filters || {
          search: null,
          settingsIds: [],
          organizationIds: []
        }
        this.defaultSettings = pageProp?.defaultSettings || false
        await this.getOrgSettings(true)
      })
  },
  mounted() {
    this.$root.$on('actionOrgSettings', this.actionOrgSettings)
    this.$root.$on('changeSizeNavbar', this.changeSizeNavbar)
  },
  beforeDestroy() {
    this.$root.$off('actionOrgSettings', this.actionOrgSettings)
    this.$root.$off('changeSizeNavbar', this.changeSizeNavbar)
  },
  components: {
    NavBar,
    OrgsList,
    EmptyBlock,
    VuetiTable,
    SearchInput,
    ModeButtons,
    ScrollShadow,
    MenuComponent,
    OrganizerSettingEdit,
    OrganizerSettingCopy,
    OrganizerSettingMenu,
    OrganizerSettingCard,
    PinnedFiltersTemplatesTenders,
  }
}
</script>
<style lang="scss">
.block-filters {
  display: grid;
  grid-template: minmax(50px, auto) / 130px 1fr 40px;
}
.label-filter {
  margin: auto 0;
  text-transform: uppercase;
  font-weight: 500;
  font-size: 12px;
  text-overflow: unset;
  overflow: unset;
}
.table-loading {
  border-radius: 10px;
  border: thin solid var(--color-main-green) !important;
  &-header {
    height: 40px;
    border-radius: 10px 10px 0 0;
    background-color: var(--v-secondary__green_chosen-base);
    border-bottom: thin solid var(--color-main-green) !important;
  }
  &-row {
    height: 57px;
    background-color:var(--v-main__light_green-base);
    border-bottom: thin solid var(--color-main-green) !important;
  }
}
#orgSettings {
  td[data-qa="tdmenu"] {
    position: relative;
    padding: 3px !important;
  }
}
</style>
<style scoped lang="scss">
::v-deep .setting-meny-item .type-name{
  line-height: 1;
  padding: 5px 0;
}
/*::v-deep .setting-meny-content {
  height: calc(100vh - 195px) !important;
  &.mini .setting-meny-item{
    padding-left: 0 !important;
  }
}*/
/*.setting-meny-head {
  position: sticky;
  top: 0px;
  padding: 0 5px 5px;
  z-index: 1;
  padding-bottom: 5px;
  background: var(--v-main__light_green-base);
  &.mini {
    width: 93px;
  }
}*/
.value-key {
  opacity: 0.8;
  font-size: 12px;
}
.value-label {
  max-width: 100%;
  overflow: auto;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-wrap: anywhere;
}
</style>
